module.exports = __webpack_public_path__ + "img/team-internship-bg.73e95027.svg";